import { useEffect } from 'react'

/**
 * Đưa trang đang xem về trang cuối khi nó vượt quá số trang hiện có.
 *
 * Danh sách phân trang theo URL co lại được — đơn rời danh sách, link cũ, sửa
 * tay `?page=` — và đứng ở trang vượt quá thì API trả rỗng: màn báo "không có
 * dữ liệu" sai trong khi trang trước vẫn còn, nút Trước/Sau cũng chỉ đưa tới
 * một trang rỗng khác. `totalPages` chưa biết (đang tải) thì không làm gì.
 * `goTo` nên thay chỗ trong lịch sử (replace) để Back không quay về trang rỗng.
 */
export function useClampPage(
    page: number,
    totalPages: number | undefined,
    goTo: (page: number) => void,
) {
    const lastPage = Math.max(totalPages ?? 1, 1)
    const outOfRange = totalPages !== undefined && page > lastPage
    useEffect(() => {
        if (outOfRange) goTo(lastPage)
    }, [outOfRange, lastPage, goTo])
}
